const cashout = require('../media/globals/cashoutSFX.mp3')
const confirm = require('../media/globals/confirmSFX.mp3')
const goBack = require('../media/globals/goBackSFX.mp3')
const goForward = require('../media/globals/goForwardSFX.mp3')

const play = require('../media/globals/playSFX.mp3')
const setSeed = require('../media/globals/setSeedSFX.mp3')
const switchAudio = require('../media/globals/switchSFX.mp3')
const tabChange = require('../media/globals/tabChangeSFX.mp3')
const error = require('../media/globals/errorSFX.mp3')
const notification = require('../media/globals/notificationSFX.mp3')

const multiply = require('../media/globals/multiplySFX.mp3')
const divide = require('../media/globals/divideSFX.mp3')
// const divideN = require('../media/globals/divideSFXN.mp3')

const cashoutSFX = new Audio(cashout.default ? cashout.default : cashout)
const confirmSFX = new Audio(confirm.default ? confirm.default : confirm)

const goBackSFX = new Audio(goBack.default ? goBack.default : goBack)
const goForwardSFX = new Audio(
  goForward.default ? goForward.default : goForward,
)
const playSFX = new Audio(play.default ? play.default : play)
const errorSFX = new Audio(error.default ? error.default : error)
const notificationSFX = new Audio(
  notification.default ? notification.default : notification,
)
const setSeedSFX = new Audio(setSeed.default ? setSeed.default : setSeed)
const switchSFX = new Audio(
  switchAudio.default ? switchAudio.default : switchAudio,
)
const tabSFX = new Audio(tabChange.default ? tabChange.default : tabChange)
const multiplySFX = new Audio(multiply.default ? multiply.default : multiply)
const divideSFX = new Audio(divide.default ? divide.default : divide)

export default {
  divideSFX,
  multiplySFX,
  goForwardSFX,
  goBackSFX,
  playSFX,
  cashoutSFX,
  confirmSFX,
  notificationSFX,
  errorSFX,
  setSeedSFX,
  switchSFX,
  tabSFX,
}
